<template>
  <form class="bin" v-on:submit.prevent="Send">
    <Modal
      v-if="Modal"
      :Titulo="Titulo"
      :Texto="Texto"
      :Color="Color"
      @Aceptar="Aceptar"
    />
    <h1>egep</h1>
    <h3>Consultores</h3>
    <p>Enter new password</p>
    <div class="input" data-v-step="2">
      <font-awesome-icon icon="lock" class="icono" />
      <input
        type="password"
        name="Password"
        placeholder=" Password"
        v-model="password1"
        required
      />
    </div>
    <p>Confirm new password</p>
    <div class="input" data-v-step="2">
      <font-awesome-icon icon="lock" class="icono" />
      <input
        type="password"
        name="Password"
        placeholder=" Password"
        v-model="password2"
        required
      />
    </div>

    <button type="submit">CONFIRM</button>
  </form>
</template>
<script>
import Modal from "../../components/Modal.vue";
export default {
  data: () => ({
    password1: "",
    password2: "",
    Modal: false,
    Titulo: "Error",
    Texto: "Passwords do not match",
    Color: "background: red;",
  }),
  components: { Modal },
  methods: {
    Send() {
      if (
        this.password1 != "" &&
        this.password2 != "" &&
        this.password1 == this.password2
      ) {
        this.$router.push({ path: "/login" });
      } else {
        this.Modal = true;
      }
    },
    Aceptar() {
      this.Modal = false;
    },
  },
};
</script>
<style lang="css" scoped>
.bin {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.input {
  width: 100%;
  color: var(--second-color);
}
.input input {
  width: 60%;
  margin: 1rem;
  height: 45px;
  border: none;
  background: var(--dark-firts-color);
  color: var(--second-color);
  border-radius: 15px;
  padding-left: 40px !important;
  padding: 5px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  outline: none;
  margin-top: -20px;
}

input::placeholder {
  color: var(--second-color);
  font-family: Poppins, Regular;
  font-weight: 400;
}
.icono {
  position: absolute;
  pointer-events: none;
  color: var(--second-color);
  font-size: 1.5rem;
  margin: 25px;
  margin-left: 30px;
  margin-top: -5px;
}
.bin p {
  color: var(--eleventh-color);
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 1.5rem;
}
.bin a {
  text-decoration: none;
  color: var(--dark-third-color);
  width: 100%;
  text-align: end;
  margin-right: 41%;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}
.bin button {
  background: var(--firts-color);
  width: 60%;
  margin: 1rem;
  height: 2.7rem;
  border: none;
  border-radius: 15px;
  color: var(--second-color);
  font-size: 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.bin h1 {
  display: none;
}
.bin h3 {
  display: none;
}
.bin span {
  display: none;
}

@media (max-width: 800px) {
  .bin {
    color: var(--second-color);
  }
  .bin p {
    color: var(--second-color);
    font-size: 1rem;
  }
  .bin h1 {
    display: block;
    font-size: 100px;
    text-align: center;
    margin: 0;
    color: var(--sixth-color);
    margin-bottom: -15px;
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .bin h3 {
    display: block;
    font-size: 42px;
    margin: 0;
    text-align: center;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .bin a {
    color: var(--second-color);
    margin-bottom: 30px;
  }
  .bin span {
    display: block;
    margin: 10%;
    font-size: 1.5rem;
    text-align: center;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
  }
}
@media (max-width: 500px) {
  .Content input {
    width: 85%;
  }
}
</style>